import * as React from 'react';
import GraphView from "./GraphView";

export default function GraphPage() {
  return (
        <GraphView height={600} defaultTime={1500} mode='full' mx={'10%'} format='%d/%m %Hh'/>
  );
}

